// Get Refer Connections
export const GET_REFERRALS_CONNECTIONS_REQUEST = 'GET_REFERRALS_CONNECTIONS_REQUEST';
export const GET_REFERRALS_CONNECTIONS_DONE = 'GET_REFERRALS_CONNECTIONS_DONE';
export const GET_REFERRALS_CONNECTIONS_FAILED = 'GET_REFERRALS_CONNECTIONS_FAILED';

// Operations
export const REFERRALS_CONNECTIONS_SET_PAGE = 'REFERRALS_CONNECTIONS_SET_PAGE';
